import React, { useEffect, useState } from "react";
import { styled, useTheme, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useLocation, useHistory } from "react-router-dom";
import {
  FaFileAlt,
  FaRobot,
  FaSignInAlt,
  FaCloudUploadAlt 
} from "react-icons/fa";
import Topnavbar from "./Topnavbar";
import profile from "../../assets/img/user.png";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useMsal } from "@azure/msal-react";
import Getusers from "../auth/Getusers";
import axios from "axios";
// import { useOktaAuth } from "@okta/okta-react";
import { loginRequest } from "../auth/authConfig";

const drawerWidth = 300;


const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  // backgroundImage: `linear-gradient(rgba(0,0,160,0.5), rgba(47, 46, 53,0.9)),url(${bgimg})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  background: "#000",
  color: "white",
  overflowX: "hidden",
  borderRight: "1px dotted rgba(86,88,105, 1) !important",
  "&& .Mui-selected": {
    outline: "0px",
    border: "0px",
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    appearance: "none",
    display: "flex",
    flexGrow: "1",
    justifyContent: "flex-start",
    alignItems: "center",
    textDecoration: "none",
    boxsizing: "border-box",
    textAlign: "left",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    position: "relative",
    textTransform: "capitalize",
    color: "rgb(32, 101, 209);",
    borderRadius: "8px !important",
    backgroundcColor: "#0000a0",
    fontWeight: "700 !important",
  },
  "&& .logoutLayout": {
    // add any additional styles for logoutLayout class here
    left: "20px !important",
  },
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: "#000",
  color: "white",
  overflowX: "hidden",
  borderRight: "1px dotted rgba(86,88,105, 1) !important",
  padding: "0px",

  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 20px)`,
  },
  "&& .Mui-selected": {
    borderRadius: "8px !important",
  },
  "&& .logoutLayout": {
    // add any additional styles for logoutLayout class here
    left: "8px !important",
  },
});

const openbox = (theme) => ({
  left: "286px !important",
});

const closebox = (theme) => ({
  left: "72px !important",
});

const listTogglebox = (theme) => ({
  padding: "0 !important",
  paddingTop: "2rem !important",
  padding: "1rem .5rem 0rem !important",
  borderRadius: "20px",
});

const listTogglebox1 = (theme) => ({
  display: "none !important",
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(4, 2.6),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "noWrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
    "& .navButtonToggle": openbox(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
    "& .navButtonToggle": closebox(theme),
    "& .listToggle": listTogglebox(theme),
    "& .listToggle1": listTogglebox1(theme),
  }),
}));

const userList = [
  {
    username:"nabasundar.rout@effem.com"
  },
  {
    username:"harshk@aaysinsight.com"
  },
  {
    username:"dwarika.patro@aaysinsight.com"
  },
  {  
    username:"himanisingh@aaysinsight.com"
  },
  {  
    username:"dipr@aaysinsight.com"
  },
  {  
    username:"nitingupta@aaysinsight.com"
  },
  {  
    username:"sanchitkumar@aaysinsight.com"
  },
  {  
    username:"sumit.shekhar@aaysinsight.com"
  },
  {
    username:"sanchitkumar@aaysinsight.com"  
  }
];

const SideNavbar = ({ LoggedinUser }) => {
  const { accounts, instance } = useMsal();
  const account = accounts?.[0];
  const [open, setOpen] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [userEmail, setUserEmail] = useState(localStorage.getItem("email"));
  const [userInfo, setUserInfo] = useState(null);
  const history = useHistory();
  const [profileImage, setProfileImage] = useState(null)


  const getProfilePhoto = async () => {
    try {
      // Ensure you acquire a token for the signed-in user
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0], // Use the first account from the authenticated accounts
      });

      const token = response.accessToken;

      console.log(token)

      // Fetch the profile photo
      const photoResponse = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
          },
          responseType: "arraybuffer", // To receive the image as binary data
        }
      );

      const blob = new Blob([photoResponse.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      setProfileImage(imageUrl);
    } catch (err) {
      console.error("Error fetching profile photo", err);
    }
  };

  useEffect(() => {
    getProfilePhoto();
  }, []);


  const { pathname } = useLocation();

  const MenuItems = [
    {
      menu: "Chat",
      route: "/",
      icon: <FaRobot className="colorCss" fontSize={24} />,
    },
    {
      menu: "Generate Summary",
      route: "/Generate-Summary",
      icon: <FaFileAlt className="colorCss" fontSize={24} />,
    },
    {
      menu: "Upload",
      route: "/upload",
      icon: <FaCloudUploadAlt  className="colorCss" fontSize={24} />,
    }
    
  ];


  useEffect(() => {
    // Save the profile image to localStorage whenever it changes
    localStorage.setItem("profileImage", profileImage);
  }, [profileImage]);

  const handleImageChange = (event) => {
    const selectedImage = event.target.files[0];

    if (selectedImage) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setProfileImage(reader.result);
      };

      reader.readAsDataURL(selectedImage);
    }
  };

  const logout = async () => {
    await instance.logoutRedirect({
      postLogoutRedirectUri: "/", // Redirect here after logout
    });
  };


  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Topnavbar open={open} />

        <Drawer className="sidenavBarstyle" variant="permanent" open={open}>
          <IconButton
            className="navButtonToggle bgColorNew borderColorNew"
            onClick={() => {
              setOpen(!open);
            }}
          >
            {open === false ? (
              <ChevronRightIcon className="colorCss" />
            ) : (
              <ChevronLeftIcon className="colorCss" />
            )}
          </IconButton>
          {open && (
            <>
              <div style={{ position: "relative", marginTop: "0px" }}>
                <div
                  style={{
                    height: "250px",
                    backgroundRepeat: "no-repeat",
                    paddingTop: "2rem",
                    marginTop: "0px",
                  }}
                >
                  <img
                    style={{
                      position: "absolute",
                      margin: "auto",
                      display: "block",
                      left: "0",
                      right: "0",
                      top: "25%",
                      borderRadius: "100%",
                      width: "150px",
                      height: "150px",
                      background: "#eee",
                    }}
                    src={profileImage || profile} // Use the selected image if available, else use the imported profile image
                    alt="Profile"
                  />
                </div>

                {/* <input
                  type="file"
                  id="imageInput"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />

                <button
                  className="btnSelectimg"
                  onClick={() => document.getElementById("imageInput").click()}
                >
                  <CameraAltIcon
                    sx={{
                      color: "#0000a0",
                      background: "white",
                      borderRadius: "6px",
                    }}
                  />
                </button> */}
              </div>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                {/* {extractNameFromEmail(userEmail)} */}
                <Getusers name={true}/>
              </div>
              <span
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                <Getusers email={true}/>
                </span>
            </>
          )}

          {!open && (
            <>
              <div
                style={{
                  position: "relative",
                  marginTop: "0px",
                  height: "110px",
                }}
              >
                <div
                  style={{
                    paddingTop: "2rem",
                    marginTop: "0px",
                    paddingBottom: "1rem",
                  }}
                >
                  <img
                    style={{
                      position: "absolute",
                      margin: "auto",
                      display: "block",
                      left: "0",
                      right: "0",
                      top: "20%",
                      borderRadius: "100%",
                      width: "50px",
                      background: "#eee",
                    }}
                    src={profileImage || profile}
                    alt="Profile"
                  />
                </div>
              </div>
            </>
          )}

          <List
            className="listToggle"
            style={{
              padding: "1.3rem",
              display: "grid",
              gridGap: "1rem",
              paddingTop: "2rem",
            }}
          >
            {/* {MenuItems.map((text, index) => (
              <a key={index} style={{ color: "white" }} href={`${text.route}`}>
               
               
                <ListItem
                  className="itemsmenulist colorCss"
                  selected={`${text.route}` === pathname}
                  disablePadding
                  sx={{ display: "block" }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 53,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                      className="colorCss"
                    >
                      {text.icon}
                    </ListItemIcon>
                    <ListItemText
                      className="listToggle1"
                      primary={text.menu}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>


              </a>

              
            ))} */}

            {MenuItems.map((menuItem, index) => {
              if (
                (menuItem.menu === "Register" ||
                  menuItem.menu === "Feedback") &&
                !userList.some((user) => user.username === userInfo?.email)
              ) {
                return null; // Do not render the menu item
              }

              return (
                // <a href={`${}`}>
                <ListItem
                  onClick={() => history.push(menuItem.route)}
                  key={index}
                  style={{ color: "white" }}
                  className="itemsmenulist colorCss"
                  selected={menuItem.route === pathname}
                  disablePadding
                  sx={{ display: "block" }}
                  title={menuItem.menu}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 53,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                      className="colorCss"
                    >
                      {menuItem.icon}
                    </ListItemIcon>
                    <ListItemText
                      className="listToggle1"
                      primary={menuItem.menu}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
                // </a>
              );
            })}

            <div
              className="logoutLayout"
              
            >
          

              <ListItem
                className="itemsmenulist itemsmenulist2  LogoutBTn"
                title="Logout"

                disablePadding
                sx={{ display: "block" }}
                onClick={() => {
                  setopenDialog(!openDialog);
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 53,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <FaSignInAlt className="colorCss" fontSize={20} />
                  </ListItemIcon>
                  <ListItemText
                    className="listToggle1 colorCss"
                    primary="Logout"
                    sx={{ opacity: open ? 1 : 0 }}
                    // onClick={logout}
                  />
                </ListItemButton>
              </ListItem>
            </div>
          </List>
        </Drawer>

        <Dialog
          open={openDialog}
          onClose={() => {
            setopenDialog(!openDialog);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="logoutPopup"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to logout ?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please confirm your decision.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setopenDialog(!openDialog);
              }}
            >
              No
            </Button>
            <Button onClick={logout}>Yes</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default SideNavbar;
